import type { UseFetchOptions } from "#app";
import axios, { type AxiosInstance } from "axios";

//@ts-ignore
const httpService: AxiosInstance = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
  withCredentials: true,
});

httpService.interceptors.request.use((config) => {
  const locale = useNuxtApp().$i18n.locale.value;
  const lang = locale || "en";
  config.withCredentials = true;
  config.params = {
    ...config.params,
    lang,
  };
  if (process.env.NODE_ENV === "development" && import.meta.env.BEARER_TOKEN)
    config.headers.Authorization = `Bearer ${import.meta.env.BEARER_TOKEN}`;
  config.headers.set("X-Timezone", Intl.DateTimeFormat().resolvedOptions().timeZone);
  if (typeof window !== "undefined") {
    config.headers.set("X-Page-Route", window.location.pathname);
    const systemId = import.meta.env.VITE_SYSTEM_ID;
    if (systemId) config.headers.set("X-System-Id", String(systemId));
  }
  return config;
});

export default httpService;

export function communityApiUrl(endpoint: string, usePrefix = true) {
  const locale = useNuxtApp().$i18n.locale.value;
  const runtimeConfig = useRuntimeConfig();
  return [runtimeConfig.public.apiBaseURL, usePrefix ? locale : "", endpoint]
    .filter((v) => v)
    .map((part) => part.replace(/^\//, ""))
    .join("/");
}

export function useFetchCommunity<T>(endpoint: string, options?: UseFetchOptions<T>) {
  const url = communityApiUrl(endpoint);
  const runtimeConfig = useRuntimeConfig();
  const headers = useRequestHeaders(["cookie", "authorization"]);
  if (process.env.NODE_ENV === "development" && runtimeConfig.appEnvToken)
    headers["authorization"] = `Bearer ${runtimeConfig.appEnvToken}`;
  const defaultOptions = {
    credentials: "include",
    headers: headers,
  };

  return useFetch<T>(url, { ...defaultOptions, ...options } as any);
}
